import request from '../request';
/*
 */
export const rechargeApi = {
  get(params) {
    return request({
      url: `/gw/w/deposit/records`,
      method: 'get',
      params,
    });
  },
  getDepositAddress(params) {
    return request({
      url: `/gw/w/deposit/address`,
      method: 'get',
      params,
    });
  },
};
